<template>
  <v-card>
    <v-card-title>
      <span class="text-h5">{{ $t('MESSAGE.REALLY_WANT_TO_REMOVE') }}</span>
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('cancel')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-container>
        <v-layout align-center justify-space-between row>
          <v-btn outlined text @click="$emit('cancel')">{{
            $t('BUTTON.CANCEL')
          }}</v-btn>
          <v-btn color="error" :loading="isLoading" @click="remove">{{
            $t('BUTTON.DELETE')
          }}</v-btn>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ItemRemove',

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  computed: {
    isLoading() {
      return this.$store.getters['loading'];
    }
  },

  methods: {
    remove() {
      this.$store.dispatch('posts/remove', this.id).then(({ data }) => {
        this.$store.commit('snackbar/setSnack', {
          status: 'success',
          text: this.$t('MESSAGE.SUCCESS')
        });
        this.$emit('success', data);
      });
    }
  }
};
</script>
